import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPersonFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={10}
    fill="none"
    viewBox="0 0 10 10"
    {...props}
  >
    <path
      fill="#7F7F7F"
      d="M5 5a2.31 2.31 0 0 1-1.7-.7 2.31 2.31 0 0 1-.7-1.7q0-1 .7-1.7A2.31 2.31 0 0 1 5 .2q1 0 1.7.7t.7 1.7-.7 1.7T5 5M.2 8.6v-.4q0-.383.208-.725.209-.342.575-.575a8.2 8.2 0 0 1 1.942-.817 7.75 7.75 0 0 1 4.15 0q1.024.284 1.942.817.366.216.575.567.208.35.208.733v.4q0 .5-.35.85t-.85.35H1.4q-.5 0-.85-.35A1.16 1.16 0 0 1 .2 8.6"
    />
  </svg>
);
export default SvgPersonFilled;
